import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
import { SectionCTA } from './SectionCTA';
export function Testimonials() {
  return <section className="bg-cream px-4 py-16" aria-labelledby="t-title" data-id="element-247" data-mp="3fznrfeogiyy7">
      <div className="mx-auto max-w-5xl" data-id="element-248" data-mp="3fxkv6cwpo9l1">
        <p className="text-center text-sm font-bold uppercase tracking-widest text-gold-dark" data-id="element-249" data-mp="3b147tkxc5z90">What professionals are saying</p>
        <h2 id="t-title" className="mt-3 text-center font-serif text-[2rem] font-bold leading-tight text-ink sm:text-5xl" data-id="element-250" data-mp="36zqyh0v1bdxc">
          Feedback from early users
        </h2>

        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-251" data-mp="2x09z116dlw9t">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-white p-6 shadow-[0_16px_40px_-24px_rgba(11,11,12,0.35)]" data-id="element-252" data-mp="2s28bo41x3asj">
              <div className="flex gap-1" aria-label="5 out of 5 stars" data-id="element-253" data-mp="v8ws66kuleb4">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-gold text-gold" aria-hidden="true" data-id="element-254" data-mp="q8iwzp4chyui" data-mpi={i} />)}
              </div>
              <blockquote className="mt-4 text-[17px] leading-relaxed text-ink" data-id="element-255" data-mp="m5b4hoxjxuic">“{t.quote}”</blockquote>
              <figcaption className="mt-auto flex items-center gap-4 border-t border-ink/10 pt-5" data-id="element-256" data-mp="78k53fnvoisq">
                <img src={t.image} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-2 ring-gold" loading="lazy" data-id="element-257" data-mp="c625ghntxpp4" />
                <div data-id="element-258" data-mp="14uzmyik7vigt">
                  <p className="font-serif text-lg font-bold text-ink" data-id="element-259" data-mp="14xddqf7v68ik">{t.name}</p>
                  <p className="text-sm text-muted" data-id="element-260" data-mp="q6cvxjl8929r">{t.role}</p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <SectionCTA label="I want the Blueprint" data-id="element-261" data-mp="1iv1y7ly0rdn3" />
      </div>
    </section>;
}